// Constants
import {
	SET_GENERAL_APP_COOKIE,
	SET_FORM_VALIDATION,
	SET_PROFILE_INFO,
	SET_LOGIN_STATE,
	RESET_DEFAULT_STATE,
	FORM_IS_INVALID,
} from '~/data/constants/authentication-constants';
import { LOGIN_URL, INDEX_URL, MY_PROFILE_URL } from '~/data/constants/router-constants';

// SERVICES
import AuthenticationService from '~/data/services/authentication-service';

import { history } from '../../helpers/history';

/**
 * Checks if the user has the app and the Strava cookies in the browser.
 * These are necessary for the user to be Logged In.
 *
 * @export
 * @returns
 */
export function checkIsLoggedIn() {
	return dispatch => {
		AuthenticationService.checkIsLoggedIn()
			.then(response => {
				// The response comes positive if the users profile data is returned
				if (response.data) {
					dispatch(setLoginState(true, true, response.data));
				}
				// If something else is returned...
				else {
					history.push({ pathname: LOGIN_URL });
					console.info('response status: ', response.status);
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					dispatch(setCookieState(false));
				}
			});
	};

	/**
	 * If it is logged in, updates:
	 * - cookieState
	 * - loginState
	 * - profileInfo
	 *
	 * @param {*} formState
	 * @param {*} cookieState
	 * @param {*} profileInfo
	 * @returns
	 */
	function setLoginState(cookieState, loginState, profileInfo) {
		return {
			type: SET_LOGIN_STATE,
			hasCookie: cookieState,
			isLoggedIn: loginState,
			profile: profileInfo,
		};
	}

	/**
	 * If has/hasn't the app + strava cookies, updates:
	 * - the hasCookie flag
	 *
	 * @param {*} cookieState
	 * @returns
	 */
	function setCookieState(cookieState) {
		return {
			type: RESET_DEFAULT_STATE,
			hasCookie: cookieState,
		};
	}
}

export function checkIsAdmin() {
	return dispatch => {
		AuthenticationService.checkIsLoggedIn()
			.then(response => {
				// The response comes positive if the users profile data is returned
				if (response.data) {
					if (response.data.admin) {
						dispatch(setLoginState(true, true, response.data));
					} else {
						history.push({ pathname: MY_PROFILE_URL });
					}
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					history.push({ pathname: INDEX_URL });
				}
			});
	};

	/**
	 * If it is logged in, updates:
	 * - cookieState
	 * - loginState
	 * - profileInfo
	 *
	 * @param {*} formState
	 * @param {*} cookieState
	 * @param {*} profileInfo
	 * @returns
	 */
	function setLoginState(cookieState, loginState, profileInfo) {
		return {
			type: SET_LOGIN_STATE,
			hasCookie: cookieState,
			isLoggedIn: loginState,
			profile: profileInfo,
		};
	}
}

/**
 * Fetches the app cookie acording to two tokens:
 * - the Company ID
 * - The Referral Email
 *
 * Upon success, the user also has to login with Strava.
 *
 * @export
 * @param {*} companyID
 * @returns
 */
export function findProfileByCookie(companyID, referralCode) {
	return dispatch => {
		AuthenticationService.findProfileByCookie(companyID, referralCode)
			.then(response => {
				// If the App's cookie + Strava cookie are present on the browser it returns an object with the company's info
				if (response.data) {
					dispatch(updateProfileData(true, response.data));
				}
			})
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else {
					// if the values inserted in the form are malformed
					if (error.response.status === 400) {
						return dispatch(checkFormValidation(false));
					}
					// If the values are correct, but there was no cookie set previously
					else if (error.response.status === 401) {
						return dispatch(setAppCookie(true, true, error.response.data[0].url));
					} else {
						return console.error('Error: ', error);
					}
				}
			});
	};

	function checkFormValidation(status) {
		return {
			type: SET_FORM_VALIDATION,
			valid: status,
		};
	}

	function setAppCookie(formState, cookieState, stravaLoginURL) {
		return {
			type: SET_GENERAL_APP_COOKIE,
			valid: formState,
			hasCookie: cookieState,
			stravaLoginURL: stravaLoginURL,
		};
	}

	function updateProfileData(loginState, profileInfo) {
		return {
			type: SET_PROFILE_INFO,
			isLoggedIn: loginState,
			profile: profileInfo,
		};
	}
}

/**
 * Logs the user out of the app, by resetting the authentication state
 *
 * @export
 * @returns
 */
export function LogOut() {
	return dispatch => {
		AuthenticationService.doTheLogOut()
			.then(response => {
				if (response.status === 200) {
					console.info('response status: ', response.status);
					dispatch(updateStore());

					setTimeout(() => {
						history.push({ pathname: INDEX_URL });
					}, 16);
				} else {
					return console.info('response status: ', response.status);
				}
			})
			// The server will return a 400 error if there is no JESSIONID cookie
			.catch(error => {
				console.error('Error: ', error.status);
			});
	};

	/**
	 * If has/hasn't the app + strava cookies, updates:
	 * - the hasCookie flag
	 *
	 * @param {*} cookieState
	 * @returns
	 */
	function updateStore() {
		return {
			type: RESET_DEFAULT_STATE,
		};
	}
}

export function formIsInvalid() {
	return {
		type: FORM_IS_INVALID,
		valid: true,
	};
}

export function userAlreadyHasAnAccount() {
	return dispatch => {
		AuthenticationService.userAlreadyHasAnAccount()
			.then(response => {
				// If the App's cookie + Strava cookie are present on the browser it returns an object with the company's info
				console.info(response.data);
			})
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 401) {
					return dispatch(setAppCookie(true, error.response.data[0].url));
				} else {
					return console.error('Error: ', error);
				}
			});
	};

	function setAppCookie(cookieState, stravaLoginURL) {
		return {
			type: SET_GENERAL_APP_COOKIE,
			hasCookie: cookieState,
			stravaLoginURL: stravaLoginURL,
		};
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/authentication-actions.jsx